import { memo } from 'react';
import { isMobile } from 'react-device-detect';
import shield_icon from 'assets/green_shield_2.svg';
import styled from 'styled-components';

import OfferDescriptionSection from './components/OfferDescriptionSection';
import PaymentActionsSection from './components/PaymentActionsSection';
import PaymentInfoSection from './components/PaymentInfoSection';




const MainContentModalSection: React.FC = () => {
  return (
    <Root >
      <Title>Payment system upgraded <br />
        for a better experience!</Title>
      <MainContent>
        <OfferDescriptionSection />
        <PaymentInfoSection />
        <PaymentActionsSection />
        <PaymentInfoSectionContainer isMobile={isMobile}>
          <PaymentInfoRow>
            <Icon src={shield_icon} />
            <PaymentInfoDescription>Transactions are processed securely.</PaymentInfoDescription>
          </PaymentInfoRow>
        </PaymentInfoSectionContainer>
      </MainContent>
    </Root >
  );
};

export default memo(MainContentModalSection);

const Root = styled.div`
  width: 55%;
  height: 100%;
  max-width: 548px;
  padding: 32px;
  background: #1D1D1D;
  border-radius: 0 12px 12px 0;
  display: flex;
  flex-direction: column; 

  @media (max-width: 768px) {
    width: 100%;
    min-height: 100vh;
    height: 100vh;
    border-radius: 0;
    padding: 24px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
  }
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (max-height: 700px) {
    gap: 10px;
  }
`;

const Title = styled.span`
  font-family: Raleway;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 12px;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 24px;
    text-align: center;
  }

  @media (max-height: 700px) {
    font-size: 16px;
    line-height: 18px;
  }
`;

const PaymentInfoRow = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
`;

const Icon = styled.img`
  width: 14px;
  height: fit-content;
`;

const PaymentInfoDescription = styled.span`
  font-family: Nunito Sans;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: #A9A9A9;
`;



const PaymentInfoSectionContainer = styled.div<{ isMobile: boolean }>`
  margin-top: ${props => props.isMobile ? '32px' : 'auto'};

  @media (max-width: 375px) {
    margin-top: 12px;
  }
`;

